export enum EnumTpComissionado {
    GerenteGeral,
    Gerente,
    Vendedor,
}